import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import { useState } from "react";
import { GoX } from "react-icons/go";
import { HiOutlineSearch } from "react-icons/hi";
import { useLocation, useSearchParams } from "react-router-dom";

export const DealerOrganizationUsersFilterBar = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(location.search);
  const [name, setName] = useState<string>(searchParams.get("name") || "");

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSearchParams({ name });
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const onClear = () => {
    setName("");
    setSearchParams(undefined);
  };

  return (
    <Flex flexDirection="row">
      <form onSubmit={onSubmit}>
        <InputGroup width={500} marginRight="16px">
          <InputLeftElement pointerEvents="none" color="gray.300">
            <HiOutlineSearch />
          </InputLeftElement>
          <Input
            value={name}
            onChange={onChange}
            placeholder="Search for staff name"
          />
          <InputRightElement>
            <Button variant="ghost" onClick={onClear}>
              <GoX />
            </Button>
          </InputRightElement>
        </InputGroup>
      </form>
    </Flex>
  );
};
